import { Component, Input, OnChanges, SimpleChanges, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons';
import { ShippingConfigService } from '../../../_services/shipping-config.service';
import { ShippingConfig } from '../../../_models/shipping-config.interface';

/**
 * Read-only-Liste der archivierten ShippingConfigs einer Operation. Wird auf
 * der Ticketseite unter der aktiven Versandkonfiguration angezeigt — pro
 * Eintrag der Versandtyp, das Versanddatum und ein Verweis auf den
 * verknuepften Lieferschein.
 *
 * Triggert beim Aendern von `refreshKey` einen Reload, damit der Parent nach
 * Anlegen einer neuen Config (Nachversand-Szenario) das Archiv aktualisieren
 * kann, sobald die zugehoerige aktive Config archiviert wurde.
 */
@Component({
  standalone: true,
  imports: [CommonModule, RouterLink, FontAwesomeModule],
  selector: 'hawk-operation-archived-shipping-configs',
  templateUrl: './operation-archived-shipping-configs.component.html',
})
export class OperationArchivedShippingConfigsComponent implements OnChanges {
  @Input() operationId!: number;
  /** Zaehler oder Marker — bei jeder Aenderung wird neu geladen. */
  @Input() refreshKey: unknown = 0;

  iconInvoice = faFileInvoice;

  protected configs = signal<ShippingConfig[]>([]);
  protected loading = signal(false);

  private shippingConfigService = inject(ShippingConfigService);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['operationId'] || changes['refreshKey']) {
      this.load();
    }
  }

  private async load(): Promise<void> {
    if (this.operationId == null) return;
    this.loading.set(true);
    try {
      const data = await this.shippingConfigService.getArchivedShippingConfigs(this.operationId);
      this.configs.set(data);
    } finally {
      this.loading.set(false);
    }
  }
}
